export const HccBlockDocumentationMarkdown = `
# Clinical Algorithm

## What does this block do?
The Clinical Algorithm block runs a configurable clinical subflow against patient data — for example, identifying suspected HCC diagnoses missing from a patient's problem list, or surfacing care gaps for chart-scrubbing in CGO workflows. It analyzes clinical indicators (documents, problems, medications, lab values, procedures) and returns the subflow's output.

## Process
1. Collects patient details from source blocks
2. Executes the selected clinical algorithm subflow
3. Evaluates data against defined criteria
4. Returns data from the Output block in the clinical algorithm subflow

## When to use it?
Use this block to run a clinical algorithm subflow over a patient's data, including:
- HCC chart review — find missing diagnoses, ensure accurate HCC code capture, optimize CMS risk adjustment and reimbursement
- Enhance comprehensive patient care
- Care gap outreach (CGO) chart scrubbing

## How to use it

1. Add the agent that hosts the clinical algorithm subflows. This is required.
2. Select the clinical algorithm subflow that matches your use case (for example, an ICD-based HCC review subflow or a care gap workflow).
3. Add the payload information needed to run the clinical algorithm. Connect these fields to the source block for fetching the correct data for the payload.

  - **Documents**: Patient's documents extracted from the Patient Data Store's document block configured to transcribe documents
  - **Problems**: Patient's conditions extracted from the Patient Data Store's Conditions block configured to fetch problems
  - **Medications**: Patient's medications extracted from the Patient Data Store's Medications block configured to fetch medications
  - **Lab Values**: Patient's lab results extracted from the Patient Data Store's LabValues block configured to fetch lab values
  - **Procedures**: Patient's surgical history extracted from the Patient Data Store's SurgicalHistories block configured to fetch procedures

## Output

If a suspect is identified, it will be returned as an object containing icd10, hccCode, and suspectText fields. In addition, metadata like the subflow run id and the state of the subflow run is returned.
`;
